import { geoFormModelToGeo, geoToGeoFormModel } from '../../../geo/components/form-geo-field/mappers';
import { Company } from '../../../providers/api/dtos';
import { CompanyFormModel } from './CompanyForm';

export const companyToCompanyFormModal = (company: Company): CompanyFormModel => ({
  address: geoToGeoFormModel(company.address),
  vatNumber: company.vatNumber || '',
  name: company.name || '',
});

export const companyFormModelToCompany = (formModel: CompanyFormModel): Company => ({
  address: geoFormModelToGeo(formModel.address) || {},
  vatNumber: formModel.vatNumber.trim(),
  name: formModel.name.trim(),
});
